const theme = {
  colors: {
    primary: '#7ACDE7',
    secondary: '#FBB6C0',
    tertiary: '#FED671',
  },
}

export default theme
